import React from 'react'
import { User } from '../../context/AuthContext'

interface AvatarProps {
  user?: User
  size?: number
  className?: string
}

const Avatar: React.FC<AvatarProps> = ({ user, size = 32, className = '' }) => {
  const getInitials = (): string => {
    if (!user) return ''

    const firstInitial = user.firstName
      ? user.firstName.charAt(0).toUpperCase()
      : ''
    const lastInitial = user.lastName
      ? user.lastName.charAt(0).toUpperCase()
      : ''

    return `${firstInitial}${lastInitial}`
  }

  const initials = getInitials()
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    fontSize: `${size / 2}px`,
  }

  return (
    <div className={`avatar ${className}`} style={style}>
      <div className="avatar__initials">{initials}</div>
    </div>
  )
}

export default Avatar
